// GENERAL
export const SINGLE_APP_PRODUCT_CODE = process.env.SINGLE_APP_PRODUCT_CODE || null;
export const LOGIN_PORTAL_URL = process.env.LOGIN_PORTAL_URL;
export const PORTRAIT_URL = process.env.PORTRAIT_URL || null;
export const MOALPRESS_URL = process.env.MOALPRESS_URL || null;
// MICRO SERVICES APIS
export const AUTH_API_URL = process.env.AUTH_API_URL;
export const PRODUCTS_API_URL = process.env.PRODUCTS_API_URL;
export const COMMAND_API_URL = process.env.COMMAND_API_URL;
// SOCKETS
export const ANNOUNCEMENTS_SOCKET_URL = process.env.ANNOUNCEMENTS_SOCKET_URL;
export const PRIVATE_MESSAGES_SOCKET_URL = process.env.PRIVATE_MESSAGES_SOCKET_URL;
export const TRADES_SOCKET_URL = process.env.TRADES_SOCKET_URL;
export const PRODUCTS_SOCKET_URL = process.env.PRODUCTS_SOCKET_URL;
//# sourceMappingURL=globalENVs.js.map